import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  EDITING_DOCUMENT__FIELD_CREATE,
  EDITING_DOCUMENT__FIELD_TARGET_SET,
  PDF_CLEAR_ALL_STATE,
} from '@app/store/actionTypes';
import { EditingDocumentAction } from '@app/store/editingDocument/actions';
import EditingDocumentFieldTarget from '@app/store/editingDocument/EditingDocumentFieldTarget';

type EditingDocumentTargetState = EditingDocumentFieldTarget | null;

const initialState: EditingDocumentTargetState = null;

export default function reducer(
  state: EditingDocumentTargetState = initialState,
  action: EditingDocumentAction | PdfAction
) {
  switch (action.type) {
    case EDITING_DOCUMENT__FIELD_CREATE:
    case PDF_CLEAR_ALL_STATE:
      return initialState;
    case EDITING_DOCUMENT__FIELD_TARGET_SET:
      return action.payload;
    default:
      return state;
  }
}
